import { IOperationalNotificationsModel } from "./model/IOperationalNotificationsModel";
import { DefaultResult, Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class OperationalNotificationsService extends ServiceBase {

    
    public async getAllStatusNotifications(): Promise<Result<IOperationalNotificationsModel[]>> {
        let url = "/api/V1/webhooks/atlassian/all";

        var result = await this.requestJson<IOperationalNotificationsModel[]>({
            url: url,
            method: "GET",
        });

        return result;
    }

}